import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Tab } from './tab.model';

@Component({
  selector: 'hs-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsComponent implements OnInit {

  @Input() tabs: Tab[];
  @Input() viewAll = false;
  @Input() auth = false;
  @Input() modal = false;

  @Input() selectedTab: Tab;
  @Output() selectedTabChange = new EventEmitter<Tab>();

  constructor() { }

  ngOnInit(): void {
    if (!this.selectedTab) {
      this.selectedTab = this.tabs[0];
    }
  }

  setSelected(tab: Tab) {
    this.selectedTab = tab;
    this.selectedTabChange.emit(tab);
  }

}
